// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VUz6","colBig":"styles_colBig__ifDqj","colSmall":"styles_colSmall__22Qfq"};